module.exports = __webpack_public_path__ + "static/media/oprah_winfrey.69115a4e.jpg";